const VALID_EMAIL_REGEXP_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/g;

export default class EmailAddress {
  private readonly _value: string;

  constructor(value: string) {
    this._value = value;
    EmailAddress.validate(value);
  }

  static validate(value: string) {
    if (!value) {
      throw new InvalidEmailAddressError('cannot be empty');
    }
    const validEmailRegExp = new RegExp(VALID_EMAIL_REGEXP_PATTERN);
    const emailIsValid = validEmailRegExp.test(value);
    if (!emailIsValid) {
      throw new InvalidEmailAddressError(value);
    }
  }

  static isValid(value: string): boolean {
    try {
      EmailAddress.validate(value);
      return true;
    } catch (error) {
      if (error instanceof InvalidEmailAddressError) {
        return false;
      }
      console.error('Unexpected error during email validation:', error);
      throw error;
    }
  }

  public isEqualTo(other?: EmailAddress): boolean {
    if (!other) {
      return false;
    }
    return this.value === other.value;
  }

  public get value(): string {
    return this._value;
  }

  public toString(): string {
    return this.value;
  }

  public static fromJSON(email: string): EmailAddress {
    if (!email) throw new Error('Email object is missing required fields');
    return new EmailAddress(email);
  }
  public toJSON(): string {
    return this.value;
  }
}

export class InvalidEmailAddressError extends Error {
  value: string;
  constructor(value: string) {
    super(`Must be in the format of [account]@[domain].[tld]`);
    this.value = value;
  }
}